export class ApiError extends Error { status:number; constructor(message:string,status=0){super(message);this.status=status;} }

export async function api<T>(path:string, init:RequestInit = {}):Promise<T>{
  const response=await fetch(`/api${path}`,{...init,headers:{accept:'application/json',...(init.body?{'content-type':'application/json'}:{}),...(init.headers||{})}});
  const data=await response.json().catch(()=>({}));
  if(!response.ok) throw new ApiError(data.error||'No pudimos completar la solicitud.',response.status);
  return data as T;
}

export function post<T>(path:string,body:unknown){return api<T>(path,{method:'POST',body:JSON.stringify(body)});}

export function money(value:number){return new Intl.NumberFormat(document.documentElement.lang==='es'?'es-US':'en-US',{style:'currency',currency:'USD'}).format(Number(value||0));}

export function cartToken(){
  const key='jerseylab_us_cart';
  let value=localStorage.getItem(key)||'';
  if(!/^[a-f0-9]{64}$/.test(value)){
    const bytes=crypto.getRandomValues(new Uint8Array(32));
    value=[...bytes].map(x=>x.toString(16).padStart(2,'0')).join('');
    localStorage.setItem(key,value);
  }
  return value;
}

export function userSessionToken(){return localStorage.getItem('jerseylab_user_session')||'';}

export function route(to:string){history.pushState({},'',to);window.dispatchEvent(new PopStateEvent('popstate'));window.scrollTo({top:0,behavior:'smooth'});}
